module.exports = __webpack_public_path__ + "img/offers.c81bd63e.svg";